export const projects = [
  {
    title: "Weavy Finance",
    subtitle: "Next.js 13.4, Tailwind CSS, TypeScript",
    description:
      "A modern financial dashboard built with Next.js 13.4, enabling users to track income, expenses, and financial insights through clean visual analytics. The dashboard features real-time balance tracking, interactive charts, and a responsive fintech-inspired UI.",
    image: "./weavy_finance.png",
    link: "https://weavy-finance-ugfv.vercel.app/",
    gitlink: "https://github.com/connorflynn4/WeavyFinance",
    hostlink: "https://weavy-finance-ugfv.vercel.app/",
  },
  {
    title: "Portfolio Website",
    subtitle: "React, Tailwind CSS, Framer Motion",
    description:
      "A modern, responsive portfolio website showcasing my professional experience, ChainXY work, and projects. Built with React and Tailwind CSS, it features Framer Motion animations, an interactive work history accordion, and a design that emphasizes clarity, animation, and responsive structure.",
    image: "./portfolio.png",
    link: "https://connorflynn-portfolio.netlify.app/",
    gitlink: "https://github.com/connorflynn4/my-portfolio",
    hostlink: "https://connorflynn-portfolio.netlify.app/",
  },
  {
    title: "North Architecture",
    subtitle:
      "Next.js, TypeScript, Tailwind CSS, shadcn/ui, Biome, Turbopack",
    description:
      "A modern architectural portfolio website highlighting luxury residential and hospitality projects. Built for performance and visual appeal using Next.js and TypeScript, with clean layouts, project case studies, and responsive galleries for immersive viewing.",
    image: "./north-architecture.png",
    link: "https://north-architecture.vercel.app/",
    gitlink: "https://github.com/connorflynn4/north-architecture",
    hostlink: "https://north-architecture.vercel.app/",
  },
  {
    title: "Cryptocurrency Information App",
    subtitle: "Vite, React, TypeScript, Tailwind CSS, Netlify",
    description:
      "A modern crypto tracking app providing real-time data and visual insights into various cryptocurrencies. Built with Vite and React, featuring dynamic charts, API integration via RapidAPI, and a clean Tailwind-based UI continuously deployed to Netlify.",
    image: "./crypto-info.png",
    link: "https://crypto-information-app.netlify.app/",
    gitlink: "https://github.com/connorflynn4/crypto-information",
    hostlink: "https://crypto-information-app.netlify.app/",
  },
  {
    title: "AI Article Summarizer",
    subtitle: "React, Vite, Redux Toolkit, Tailwind CSS, Local Storage",
    description:
      "An AI-powered article summarizer built using React and Vite. Implements RTK Query for conditional API requests, local storage for session history, and a sleek glassmorphism interface. Clean code, strong error handling, and UX-focused design.",
    image: "./ai_sum.png",
    link: "https://ai-article-summarizer-application.netlify.app/",
    gitlink: "https://github.com/connorflynn4/ai-summarizer",
    hostlink: "https://ai-article-summarizer-application.netlify.app/",
  },
  {
    title: "Coordinates Generator",
    subtitle: "HTML, CSS, JavaScript, Leaflet, Nominatim (OpenStreetMap)",
    description:
      "An interactive mapping tool that lets users generate, view, and manage latitude/longitude coordinates using Leaflet and OpenStreetMap’s Nominatim API.",
    image: "./coordgen.png",
    link: "https://connorflynn4.github.io/coordinates-generator/",
    gitlink: "https://github.com/connorflynn4/coordinates-generator",
    hostlink: "https://connorflynn4.github.io/coordinates-generator/",
  },
  {
    title: "AI Task Organizer",
    subtitle: "Next.js 13.4, GPT-4, Zustand, Appwrite, TypeScript",
    description:
      "A task management platform built with Next.js and Zustand, leveraging GPT-4 for smart task insights and Appwrite for cloud backend services. Includes drag-and-drop organization and TypeScript-based reliability for modern workflow management.",
    image: "./ai_task_org.png",
    link: "https://ai-task-organizer.vercel.app/",
    gitlink: "https://github.com/connorflynn4/ai-task-organizer",
    hostlink: "https://ai-task-organizer.vercel.app/",
  },
  {
    title: "OMDB Movie App",
    subtitle: "React, React Router, Node.js, OMDB API, Netlify",
    description:
      "A movie discovery app that lets users search the OMDB API and view detailed results with routing, state handling, and dynamic pages. Built with React, Reactstrap, and deployed on Netlify for continuous delivery.",
    image: "./omdb-movie.png",
    link: "https://omdb-movie-app-portfolio.netlify.app/",
    gitlink: "https://github.com/connorflynn4/omdb-movie-app",
    hostlink: "https://omdb-movie-app-portfolio.netlify.app/",
  },
  {
    title: "Hulu Clone",
    subtitle: "React, Next.js, Tailwind CSS, TMDB API, Vercel",
    description:
      "A responsive Hulu-inspired movie app powered by Next.js and TMDB API. Supports category-based filtering, SSR for SEO optimization, and modern UI with Tailwind CSS and Flexbox.",
    image: "./hulu-clone.png",
    link: "https://hulu-app-clone.vercel.app/",
    gitlink: "https://github.com/connorflynn4/hulu-clone",
    hostlink: "https://hulu-app-clone.vercel.app/",
  },
];

export const skills = [
  "Python (Asyncio, Scrapy, Selenium, FastAPI)",
  "JavaScript / TypeScript (React, Node, Express, Next.js)",
  "C# / .NET 6",
  "PostgreSQL / SQL",
  "Docker & CI/CD Pipelines",
  "REST & GraphQL APIs",
  "Mapbox GL / GIS Data Visualization",
  "GPT-4 API / Automation Frameworks",
  "Tailwind CSS / Framer Motion",
  "AWS, Vercel, Netlify",
  "System Design & Microservices Architecture",
];

export const workHistory = [
  {
    company: "ChainXY",
    location: "Vancouver, BC",
    positions: [
      {
        title: "Software Developer Lead",
        period: "May 2022 – Present",
        description: [
          "Led the design and development of an AI-powered scraping automation framework integrating Python, Selenium, and GPT APIs, reducing manual script maintenance by over 60% and increasing project throughput across multiple data teams.",
          "Architected and implemented asynchronous data pipelines using Python’s asyncio, enabling concurrent processing of thousands of network requests and improving data ingestion efficiency by 30%.",
          "Enhanced system reliability by modernizing legacy synchronous components, implementing centralized logging, and establishing standardized retry logic and error handling across services.",
          "Collaborated with UX and technical leads to design and deploy user-facing React.js components for the ChainXY platform, improving client workflow speed and user satisfaction.",
          "Introduced cross-team monitoring dashboards using Grafana and Prometheus to visualize API health and pipeline latency in real time, reducing downtime through proactive issue detection.",
          "Mentored junior developers on clean code, asynchronous programming, and automation best practices, strengthening the team’s technical foundation and collaboration."
        ],
        technologies: [
          "Python",
          "React.js",
          "JavaScript",
          "C#",
          ".NET 6",
          "Docker",
          "Selenium",
          "GPT API",
          "Grafana",
          "Prometheus",
        ],
      },
      {
        title: "Software Developer",
        period: "November 2019 – May 2022",
        description: [
          "Built reusable UI components and advanced data visualizations using React and Redux, improving front-end consistency and development speed.",
          "Developed and optimized backend services using C#/.NET, Node.js, and PostgreSQL to support high-volume data extraction and reporting workflows.",
          "Containerized applications with Docker, improving deployment reliability and environment parity across engineering teams.",
          "Created internal tools for QA and operations teams to manage store-level data integrity, significantly reducing manual verification workload.",
          "Standardized documentation and version control practices across teams to ensure maintainability and cross-project visibility."
        ],
        technologies: [
          "C#",
          ".NET",
          "React.js",
          "Node.js",
          "PostgreSQL",
          "Docker",
          "JavaScript",
        ],
      },
    ],
  },
  {
    company: "Paddy Power",
    location: "Ireland",
    positions: [
      {
        title: "Data Analyst",
        period: "Aug 2018 – Apr 2019",
        description: [
          "Collected, cleaned, and validated datasets from multiple sources to ensure accuracy and readiness for analysis.",
          "Performed trend and performance analysis using SQL and Excel to inform marketing and operations decisions.",
          "Developed visual dashboards using Power BI and Tableau, effectively communicating insights to cross-functional teams.",
        ],
        technologies: ["SQL", "Excel", "Power BI", "Tableau", "Data Analysis"],
      },
    ],
  },
];
